import Array from '.Array';

import * as TOKEN from './TOKEN';
export { protect } from './TOKEN';

function layerCallback (                  layer            ) { layer[TOKEN.parent] = this; }

export default          class Layer                                           extends ( Array                      
	                       
	               
	                                                      
	                                                                       
	                                                                               
    )        {
	
	[TOKEN.parent]                    = TOKEN.currentLayer;
	
	                                                                                                                          
	
	          constructor () { return super()                   ; }
	
	                                                               
	
	                                                         
	
	                                                                             
	
	get lastIndex () { return this.length - 1; }
	get lastItem () { return this[this.lastIndex]; }
	set newItem (value       ) { this[this.length] = value; }
	
	replaceWith (                                                        layers                                                        ) {
		const parent = this[TOKEN.parent] ;
		if ( layers.length===1 ) { ( parent[parent.indexOf(this)] = layers[0]  )[TOKEN.parent] = parent; }
		else {
			layers.forEach(layerCallback, parent);
			parent.splice(parent.indexOf(this), 1, ...layers);
		}
	}
	
	static default       = TOKEN.protect(Layer, true);
	
};

                                               
                                                 
                                                         